import Rename from '@/images/Rename.svg';
import { LibraryItem, LibraryItemStatus } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, ListItemText } from './components';

interface Props {
    video?: LibraryItem;
    titleRef: React.MutableRefObject<HTMLDivElement | null>;
    onChange?: () => void;
}

export const RenameMenuItem = ({ video, titleRef, onChange }: Props) => {
    const isDefaultVideo = video?.is_default;
    const isNotDoneVideo = video && video.status !== LibraryItemStatus.Done;
    const isEditable = video?.is_editable;

    if ((isDefaultVideo || isNotDoneVideo) && !isEditable) {
        return null;
    }

    return (
        <MenuItem
            onClick={() => {
                titleRef.current?.click();
                onChange?.();
            }}>
            <ListItemIcon>
                <img src={Rename} />
            </ListItemIcon>
            <ListItemText>Rename</ListItemText>
        </MenuItem>
    );
};
